import { useId } from 'react';

import { ConcernsMultiSelect } from '@/features/sessions/components/shared/ConcernsMultiSelect';

import { COPING_TYPE_OPTIONS, copingTypesLabel } from '../../constants/copingTypes';
import { useCopingTypes } from '../../hooks/useCopingTypes';

interface Props {
  clientId: string;
  /** null until the user edits the picker, which shows the current set until then. */
  value: string[] | null;
  onChange: (next: string[]) => void;
}

export function CopingTypesField({ clientId, value, onChange }: Props) {
  const id = useId();
  const { data } = useCopingTypes(clientId);
  return (
    <div className="mt-2 flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-3">
        <label htmlFor={id} className="text-meta-sm text-accent-ink font-medium">
          Coping types <span className="text-neutral-400">(optional)</span>
        </label>
        {data ? (
          <span className="text-meta-sm text-neutral-500">
            Current:{' '}
            <span className="text-accent-ink font-medium">
              {copingTypesLabel(data.copingTypes)}
            </span>
          </span>
        ) : null}
      </div>
      <ConcernsMultiSelect
        id={id}
        options={COPING_TYPE_OPTIONS}
        value={value ?? data?.copingTypes ?? []}
        onChange={onChange}
        disabled={!data}
        placeholder="Select coping types"
        clearLabel="Clear coping types"
      />
    </div>
  );
}
